<script setup>
  import { ref, onMounted, watch } from 'vue';
  import useLegacyBridge from "@/composables/useLegacyBridge";
  import useSettingsGlobals from '@/composables/useSettingsGlobals';
  import useSpotGlobals from '@/composables/useSpotGlobals';

  const model = defineModel();

  const props = defineProps({
    spotInfo: {
      type: Object,
      required: true
    },
    selectedModelId: {
      type: [String, Number],
      required: false
    },
    useSavedState: {
      type: Boolean,
      default: true
    },
    updateKey: {
      type: Number,
      default: () => Date.now
    }
  });

  const { $WEB_VIEW, $PLATFORM } = useSettingsGlobals();
  const spotGlobals = useSpotGlobals();

  const { forecastTable } = useLegacyBridge();

  const contentContainer = ref(null);
  const modelSelectorContainer = ref(null);
  const modelNameContainer = ref(null);
  const modelName = ref(null);
  
  function loadForecastTable() {
    const settings = {
      modelData: {...props.spotInfo.forecastModelData},
      modelSelectorTarget: modelSelectorContainer.value,
      modelNameTarget: modelNameContainer.value,
      spotName: props.spotInfo.spotName,
      spotId: props.spotInfo.spotId,
      favSpotId: props.spotInfo.spotFavoriteId,
      lat: props.spotInfo.lat,
      lon: props.spotInfo.lon,
      mainRows: 'wind,gust,sky,temp,wave',
      moreRows: 'precip,cloud,pres,run',
      showBasicDetailedToggle: false,
      showDaily7DayToggle: false,
      dailyMode: 'detailed',
      sevenDayMode: 'basic',
      useExternalControls: true, 
      useSavedState: props.useSavedState,
      setFixedWidth: false
    }

    if (props.selectedModelId) {
      settings.selectedModelId = props.selectedModelId
    }
    
    if ($WEB_VIEW) {
      settings.selectedModelId = spotGlobals.$FX_MODEL_ID ? spotGlobals.$FX_MODEL_ID : null;
      settings.modelChanged = modelChanged;
    }
    
    model.value = forecastTable(contentContainer.value, settings);
  }

  const modelChanged = (modelId) => {
    if ($PLATFORM == 'android') {
        if (props.spotInfo.spotId) {
            const event = 'modelchanged,' + props.spotInfo.spotId + ',' + modelId;

            alert(event);
        }
    } else {
        const info = {
            type: 'fx-model-id',
            fxModelId: modelId,
        };

        try {
            window.webkit.messageHandlers.observe.postMessage(info);
        } catch (error) {
            console.warn('Error saving selected forecast table model: ', error);
        }
    }
  }

  onMounted(() => {
    loadForecastTable();
  })

  window.$EventBus.addEventListener('cosmos-forecast-table-rendered', (e) => {
    if (!e.detail.modelDataSet) return;
    
    modelName.value = e.detail.modelDataSet.model_name;
  })  

  watch(() => props.updateKey, () => {
    contentContainer.value.innerHtml = "";
    modelSelectorContainer.value.innerHtml = "";
    modelNameContainer.value.innerHtml = "";
    model.value.refresh();
  })
</script>

<template>
  <div
    class="jwx-data-container__scrolling-submenus jw-model-selector-container"
    ref="modelSelectorContainer"
  ></div>
  <div
    class="jwx-data-container__meta-info jw-model-selector-container"
    ref="modelNameContainer"
  >
    <p class="jwx-data-container__meta-text">{{ modelName }}</p>
</div>
  <div
    class="jwx-data-container__content"
    style="width: 100%;"
    ref="contentContainer"
  ></div>
</template>